import { render, staticRenderFns } from "./OptView.vue?vue&type=template&id=d4732826&scoped=true"
import script from "./OptView.vue?vue&type=script&lang=js"
export * from "./OptView.vue?vue&type=script&lang=js"
import style0 from "./OptView.vue?vue&type=style&index=0&id=d4732826&prod&lang=scss&scoped=true"
import style1 from "./OptView.vue?vue&type=style&index=1&id=d4732826&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4732826",
  null
  
)

export default component.exports